import { ConstructionLoanType, ConstructionToPermanentStatus } from '@willow/graphql-iso/src/app';
import { ConstructionStatus } from '@willow/types-iso';

import { assertNever } from './assertNever';

export const formatConstructionDescription = (
  constructionLoanType: ConstructionLoanType | undefined,
  constructionToPermanentStatus: ConstructionToPermanentStatus | undefined,
) => {
  if (constructionLoanType && constructionToPermanentStatus) {
    return `${formatConstructionLoanType(constructionLoanType)} (${formatConstructionToPermanentStatus(
      constructionToPermanentStatus,
    )})`;
  }
  return 'Non-Construction';
};

export const formatConstructionLoanType = (constructionLoanType: ConstructionLoanType) => {
  switch (constructionLoanType) {
    case 'constructionOnly':
      return 'Construction';
    case 'constructionToPermanent':
      return 'Construction to Perm';
  }
};

export const formatConstructionToPermanentStatus = (constructionToPermanentStatus: ConstructionToPermanentStatus) => {
  switch (constructionToPermanentStatus) {
    case 'active':
      return 'Active';
    case 'permanent':
      return 'Perm';
  }
};

export const formatConstructionStatus = (constructionStatus: ConstructionStatus) => {
  switch (constructionStatus) {
    case 'NON_CONSTRUCTION':
      return 'Non-Construction';
    case 'CONSTRUCTION_ACTIVE':
      return 'Construction (Active)';
    case 'CONSTRUCTION_TO_PERMANENT_ACTIVE':
      return 'Construction to Perm (Active)';
    case 'CONSTRUCTION_TO_PERMANENT_PERMANENT':
      return 'Construction to Perm (Perm)';
    default:
      assertNever(constructionStatus);
  }
};
